import { FC } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { LOGISTIC_BOX_ALLOWED_EMAILS, LOGISTIC_BOX_OPEN_SLUGS, LOGISTIC_BOX_ROLES, PublicRoutes } from '../constants/routes'
import { IUser } from '../models/user.model'

/**
 * Acceso al módulo "Logística de cajas".
 *
 * Regla:
 *   - En los slugs "abiertos" (LOGISTIC_BOX_OPEN_SLUGS, ej. Falabella) lo puede
 *     ver CUALQUIER usuario logueado, sin filtro de rol ni de correo.
 *   - En el resto de sellers sigue restringido: rol permitido (admin/jefe) Y
 *     correo en la lista de liberación gradual.
 *   - Para el slug 'wom' no se valida que el usuario esté logueado.
 */
const LogisticBoxRouterGuard: FC = () => {
  const userState = useSelector((store: { user: IUser }) => store.user)
  const { slug } = useParams<{ slug: string }>()

  const isOpenSlug = LOGISTIC_BOX_OPEN_SLUGS
    .map(s => s.toLowerCase())
    .includes(String(slug ?? '').toLowerCase())

  const userEmail = String(userState.email ?? '').toLowerCase().trim()
  const byRoleAndEmail = LOGISTIC_BOX_ROLES.includes(userState.id_role) &&
    LOGISTIC_BOX_ALLOWED_EMAILS.map(e => e.toLowerCase()).includes(userEmail)

  const isWom = String(slug ?? '').toLowerCase().trim() === 'wom'
  const loggedIn = isWom || userState.id > 0

  const allowed = loggedIn && (isOpenSlug || byRoleAndEmail)

  return allowed
    ? <Outlet />
    : <Navigate replace to={PublicRoutes.LOGIN.replace(':slug', String(slug))} />
}

export default LogisticBoxRouterGuard
